import { ChevronDown } from 'lucide-react';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@predoc/cow';
import { FacesheetImage } from './types';

const hasAnySignedUrl = (items: FacesheetImage[]): boolean =>
  items.some((item) => item.signedUrl);

interface ViewFacesheetAssetsMenuProps {
  resultsSummaries: FacesheetImage[];
  sources: FacesheetImage[];
  onViewImage: (signedUrl: string) => void;
}

export const ViewFacesheetAssetsMenu = ({
  resultsSummaries,
  sources,
  onViewImage,
}: ViewFacesheetAssetsMenuProps) => {
  const showSummarySection = resultsSummaries.length > 0;
  const showSourcesSection = sources.length > 0;

  const hasValidImages =
    hasAnySignedUrl(resultsSummaries) || hasAnySignedUrl(sources);

  if (!showSummarySection && !showSourcesSection) {
    return (
      <Button variant="outline" size="sm" disabled>
        View
      </Button>
    );
  }

  if (!hasValidImages) {
    return (
      <Button variant="outline" size="sm" disabled>
        View
      </Button>
    );
  }

  const handleItemSelect = (signedUrl?: string) => {
    if (signedUrl) {
      onViewImage(signedUrl);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline" size="sm" className="gap-1">
          View
          <ChevronDown className="size-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="end"
        className="max-h-[280px] overflow-y-auto"
      >
        {showSummarySection &&
          resultsSummaries.map((item, index) => (
            <DropdownMenuItem
              key={item.id}
              disabled={!item.signedUrl}
              onSelect={() => handleItemSelect(item.signedUrl)}
              className="font-medium"
              aria-label={`Summary ${index + 1}`}
            >
              Summary {index + 1}
            </DropdownMenuItem>
          ))}
        {showSummarySection && showSourcesSection && <DropdownMenuSeparator />}
        {showSourcesSection && (
          <div className="px-2 py-1.5 text-sm font-semibold">Sources</div>
        )}
        {showSourcesSection &&
          sources.map((item, index) => (
            <DropdownMenuItem
              key={item.id}
              disabled={!item.signedUrl}
              onSelect={() => handleItemSelect(item.signedUrl)}
              className="font-medium"
              aria-label={`Source ${index + 1}`}
            >
              Source {index + 1}
            </DropdownMenuItem>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
